import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { cartQueryKey } from '@hooks/useCart/useCart';
import { removeCoupon } from '@services/couponService';
import type { ShoppingCartDTO } from '@t/api.types';

export interface UseRemoveCouponOptions {
  onSuccess?: (cart: ShoppingCartDTO) => void;
  onError?: (error: Error) => void;
}

export const useRemoveCoupon = (
  sessionId: string,
  { onSuccess, onError }: UseRemoveCouponOptions = {}
): UseMutationResult<ShoppingCartDTO, Error, void> => {
  const queryClient = useQueryClient();
  return useMutation<ShoppingCartDTO, Error, void>({
    mutationFn: () => removeCoupon(sessionId),
    onSuccess: (cart) => {
      queryClient.setQueryData<ShoppingCartDTO>(cartQueryKey(sessionId), cart);
      onSuccess?.(cart);
    },
    onError,
  });
};
